import ImageZoom from "react-medium-image-zoom";
import React from "react";
import styles from "./ProfileImage.module.scss";
import * as classnames from "classnames";

//TODO replace with simple image with thumbnail
export default ({ image, src, alt, style }) =>
  <span>
    <ImageZoom image={{
      src: image || src,
      alt: alt || 'Profile Picture',
      className: classnames(styles.image, style)
    }}/>
  </span>
